export default import.meta.ROLLUP_FILE_URL_8zNhtWFBOfAe3WuL7mg5Ig;